module.exports = __webpack_public_path__ + "img/RS-M-10.56ec1d51.svg";